import React, { FC, memo } from 'react'

import { Heading } from '@ucheba/ui/components/Heading/desktop'

import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { IProps } from '../types'

import SC from '../base/InstitutionGraduatesJob.styles'

const { List, Logo } = SC

const InstitutionGraduatesJob: FC<IProps> = ({ list, titleSize = 'h2' }) => {
  if (list.length === 0) {
    return null
  }

  return (
    <>
      <Heading as={titleSize} h2='Где работают выпускники' spacing='large' />

      <List>
        {list.map((item) => {
          const { id, logo, name } = item

          if (logo?.fallbackUrl || logo?.webp) {
            return (
              <Tooltip
                key={id}
                content={<Text color='black'>{name}</Text>}
                position='right-center'
                width='200px'
              >
                <Logo
                  alt='логотип компании'
                  webpUrl={logo?.webp}
                  fallbackUrl={logo?.fallbackUrl}
                />
              </Tooltip>
            )
          }

          return null
        })}
      </List>
    </>
  )
}

export default memo(InstitutionGraduatesJob)
